// extracted by mini-css-extract-plugin
export default {"navbar":"Nb_navbar__GZti8","company-name":"Nb_company-name__WptLN","box":"Nb_box__PDirt","sort":"Nb_sort__4Teas"};